module.exports = __webpack_public_path__ + "img/tu-6.ba9b6781.png";